import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Atto } from '../../../models/atto';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { SezioneAttiFull } from '../../../models/sezioni/sezione-atti-full';
import { AttiModifyConcreteFormComponent } from './atti-modify-concrete-form.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [atti-mod-modify]',
  templateUrl: 'atti-mod-modify.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class AttiModModify {
  @Output() onReturn: EventEmitter<SezioneAttiFull> = new EventEmitter<SezioneAttiFull>();
  @Output() attoMod: EventEmitter<Atto> = new EventEmitter<Atto>();
  @ViewChild('formAttiModify') formAtti: AttiModifyConcreteFormComponent;

  inizializza(sezione: SezioneAttiFull, atto: Atto, fascicolo: FascicoloFull, urlUpdate: string) {
    this.formAtti.inizializza(sezione, atto, fascicolo, urlUpdate);
    openModal('modalmodifyAtti');
  }

  createForm() {
    this.formAtti.createForm(true);
  }

  manageModal(sezioneAtti: SezioneAttiFull) {
      closeModal('modalmodifyAtti');
      this.onReturn.emit(sezioneAtti);
  }

  getAttoMod(atto: Atto){
    this.attoMod.emit(atto);
  }
}
